import { gsap, WF_EASE } from './gsap'

type Cleanup = (() => void) | void

/**
 * FAQ accordion (Webflow click lists a-52 open / a-53 close) used on pricing and
 * contact. Click toggles the answer height (0 <-> auto), rotates the icon 45deg,
 * and shifts the border colour.
 */
export const setupFaq = (root: HTMLElement): Cleanup => {
    const blocks = Array.from(root.querySelectorAll<HTMLElement>('.faq-block'))
    if (!blocks.length) return

    const cleanups: Array<() => void> = []

    blocks.forEach((block) => {
        const answer = block.querySelector<HTMLElement>('.faq-answer-holder')
        const icon = block.querySelector<HTMLElement>('.faq-icon')

        if (answer) gsap.set(answer, { height: 0, overflow: 'hidden' })

        let open = false

        const toggle = (): void => {
            open = !open

            if (answer) gsap.to(answer, { height: open ? 'auto' : 0, duration: 0.7, ease: WF_EASE })
            if (icon) gsap.to(icon, { rotation: open ? 45 : 0, duration: 0.7, ease: WF_EASE })

            gsap.to(block, {
                borderColor: open ? 'rgb(243, 177, 165)' : 'rgb(48, 54, 61)',
                duration: 0.7,
                ease: WF_EASE
            })
        }

        block.style.cursor = 'pointer'
        block.addEventListener('click', toggle)
        cleanups.push(() => block.removeEventListener('click', toggle))
    })

    return () => cleanups.forEach((fn) => fn())
}
